import AddTemplate from './components/AddTemplate';
export default () => {
  return <AddTemplate />;
};
